import { Layout } from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";

const Terms = () => {
  return (
    <Layout>
      <SEO 
        title="Terms of Service | Bookkeeping Services South Africa"
        description="Terms and conditions for our bookkeeping services. Understand our service agreement, client responsibilities, payment terms, and more."
        canonical="/terms"
      />
      <section className="py-16 lg:py-24 section-accent">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-6">
              Terms of Service
            </h1>
            <p className="text-lg text-muted-foreground">
              Last updated: January 2026
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 section-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto prose prose-slate">
            <div className="space-y-8">
              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Services Agreement
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  By engaging Bookkeeping Services South Africa for bookkeeping, payroll, 
                  or related services, you agree to these terms of service. Our services 
                  are provided as described in your selected package or custom agreement.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Client Responsibilities
                </h2>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Provide accurate and complete financial information</li>
                  <li>Submit documents in a timely manner</li>
                  <li>Review and approve work before submission deadlines</li>
                  <li>Pay invoices according to agreed terms</li>
                  <li>Notify us of any changes to business structure or operations</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Our Responsibilities
                </h2>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Provide services with professional care and competence</li>
                  <li>Meet agreed deadlines where possible</li>
                  <li>Maintain confidentiality of all client information</li>
                  <li>Communicate proactively about compliance requirements</li>
                  <li>Keep accurate records of all work performed</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Payment Terms
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Monthly packages are billed in advance. Payment is due within 7 days 
                  of invoice. Late payments may result in service suspension. Additional 
                  work outside the package scope will be quoted separately.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Limitation of Liability
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  While we exercise due professional care, we cannot guarantee specific 
                  outcomes with SARS or other regulatory bodies. Clients remain ultimately 
                  responsible for the accuracy of information provided to us.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Termination
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Either party may terminate services with 30 days written notice. 
                  Upon termination, we will return all client documents and provide 
                  handover assistance as reasonably required.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Contact
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  For questions about these terms, contact us at:{" "}
                  <a href="mailto:info@bookkeepingservices.co.za" className="text-primary hover:underline">
                    info@bookkeepingservices.co.za
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Terms;
